export const appActionTypes = {
  COMPONENT_MOUNT: 'COMPONENT_MOUNT',
  REGISTER_REDUCER: 'REGISTER_REDUCER'
};

export function componentMount(ComponentInstance, componentName, sagas) {
  return {
    type: appActionTypes.COMPONENT_MOUNT,
    state: {
      component: ComponentInstance,
      name: componentName,
      sagas
    },
  }
}

export function registerReducer(stateKey, reducer){
  return dispatch => {
    dispatch({
      type: appActionTypes.REGISTER_REDUCER,
      state: {
        [stateKey]: reducer,
      },
    });
  };
}



// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/application/appActions.js